import React, { ReactNode } from 'react'
import styles from './styles.module.scss'
import cl from 'classnames'

interface TextBaseProps extends React.HTMLAttributes<HTMLParagraphElement> {
  children?: ReactNode
  className?: string
}

export const TextBase = ({ children, className }: TextBaseProps) => {
  return <p className={cl(styles.paragraph, className)}>{children}</p>
}
